
import { SearchTravelSortItem } from '@/types/models'
import { computed, defineComponent, PropType, ref } from 'vue'

import EasyDrop from "@/components/EasyDrop.vue";

export default defineComponent({
    name: "TravelSorting",
    emits: ['updateSort'],
    components: {
        EasyDrop
    },
    props: {
        sortItems: {
            type: Array as PropType<Array<SearchTravelSortItem>>,
            required: true
        },
        pageTexts: {
            type: Object,
            required: true
        }

    },
    setup(_props, { emit }) {

        const easyDrop = ref();

        const selectedSortName = () => {
            const selectedSort = _props.sortItems.find(
                (x) => x.selected === true
            );
            return selectedSort ? selectedSort.name.toLowerCase() : "";
        };

        const sortButtonText = computed(() => {
            return _props.pageTexts['hotelListPageSearchResultSortByLabelYouSee'].replace(/\[[selected\]]+\]/g, selectedSortName);
        });

        const updateSort = (sortItem: SearchTravelSortItem) => {
            emit('updateSort', sortItem);
        };

        const closeDropdown = () => {
            if (easyDrop.value)
                easyDrop.value.toggleDropdown();
        }

        return {
            easyDrop,
            sortButtonText,
            updateSort,
            closeDropdown
        }
    },
})
